import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import {
  GetCustListByStore,
  EditSalesOrderApi,
  GetAllTerms,
  getPartDataListByStoreFilter,
  GetAllShipMethod,
  GetCustomerById,
  GetSalesOrderDataByID,
  GetSalesOrderPartsByID,
  GetAllSOStatus,
  PrintQuoteApi,
  GetSaleOrderFileApi,
  AddSalesOrderFileApi,
  DeleteSalesOrderFileApi,
  GetAllSaleOrderNotes,
} from "../../api";
import { useStateContext } from "../../contexts/ContextProvider";
import "../../styles/sale.css";
import { Card } from "react-bootstrap";
import "../../styles/viewCustomer.css";
import { Col, Container, Row } from "react-bootstrap";
import { Header } from "../../components";
import { validateField } from "../../contexts/Utils";
import DateTimeField from "../../components/DateTimeField";
import Select from "react-select";
import { usePromiseTracker, trackPromise } from "react-promise-tracker";
import LoadingIndicator from "../LoadingIndicator";
import CartListTable from "../../components/CartListTable";
import PosForm2 from "../../components/PosForm2";
import { showSuccessToast, showErrorToast } from "../../components/ToastMesg";
import AttachFileOrder from "../../components/AttachFileOrder";

const EditQuotation = () => {
  let param = useParams();
  var so_id_param = param.so_ids;
  const {
    currentColor,
    defaultImageMode,
    imageMode,
    setActiveProdMenu,
    setActiveProdMenuId,
    userID,
  } = useStateContext();
  const [CustomerOptions, setCustomerOptions] = useState([]);
  const [soStatusOptions, setSoStatusOptions] = useState([]);
  const [soNoteOptions, setSoNoteOptions] = useState([]);
  const [termsOptions, setTermsOptions] = useState([]);
  const [shipMethodOptions, setShipMethodOptions] = useState([]);
  const [partOptions, setPartOptions] = useState([]);
  const [CartList, setCartList] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [removedFiles, setRemovedFiles] = useState([]);
  const [isPageFrozen, setIsPageFrozen] = useState(false);
  const [store_id, setStore_id] = useState(0);
  const [oDatetime, setODatetime] = useState("");
  const [errors, setErrors] = useState([]);
  const { promiseInProgress } = usePromiseTracker();
  const [loading, setloading] = useState(false);

  const [formData, setFormData] = useState({
    est_sale: "Q",
    customer: "select",
    customer_po: "",
    sales_rep: "",
    terms: "select",
    ship_method: "select",
    so_notes: "select",
    tracking_no: "",
    b_to: "",
    b_street: "",
    b_city: "",
    b_state: "",
    b_zip: "",
    b_country: "",
    b_phone2: "",
    s_to: "",
    s_street: "",
    s_city: "",
    s_state: "",
    s_zip: "",
    s_country: "",
    s_phone: "",
    discount_label: "Discount",
    amount_paid: 0,
    amount_pending: 0,
    total_discount: 0,
    sub_total: 0,
    total_items: 0,
    grand_total: 0,
    tax: 0,
    shipping: 0,
    references: "",
    note: "",
    user_note: "",
    store_id: 0,
    status: 1100,
    o_datetime: "",
  });
  const [partData, setPartData] = useState({
    type: "part",
    part: "select",
    qty: "1",
    price: "0",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "part") {
      setPartData((prev) => ({
        ...prev,
        part: {
          ...prev.part,
          description: value,
        },
      }));
    }
    if (["qty", "price"].includes(name))
      setPartData((prev) => ({ ...prev, [name]: value }));
    else if (
      [
        "quantity",
        "unit_price",
        "notes",
        "req_date",
        "ship_date",
        "shipment",
      ].includes(name)
    ) {
      const index = parseInt(e.target.getAttribute("data-index"));
      setCartList((prev) =>
        prev.map((item, i) => {
          if (i !== index) return item;
          const updated = { ...item, [name]: value };
          return {
            ...updated,
            total:
              parseFloat(updated.quantity) * parseFloat(updated.unit_price) ||
              0,
          };
        }),
      );
    } else if (name === "status") {
      const ss = soStatusOptions?.find((item) => item.label === e.target.value);
      setFormData((prev) => ({ ...prev, status: ss }));
    } else if (name === "so_notes") {
      const sn = soNoteOptions?.find((item) => item.label === e.target.value);
      setFormData((prev) => ({ ...prev, so_notes: sn }));
    } else if (
      ["total_discount", "tax", "shipping", "amount_paid"].includes(name)
    ) {
      setFormData((prev) => ({ ...prev, [name]: value }));
    } else setFormData((prev) => ({ ...prev, [name]: value }));
    const error = validateField(name, value, name);
    setErrors((prev) => ({ ...prev, [name]: error }));
  };

  const handleSelectChange = async (option, e) => {
    if (option && option.value) {
      if (e.name === "part")
        setPartData((prev) => ({
          ...prev,
          [e.name]: option,
          qty: 1,
          price: option.sale_price,
        }));
      else if (e.name === "customer") {
        await GetCustomerById(option.value)
          .then((result) => {
            setFormData((prev) => ({
              ...prev,
              customer: option,
              terms: result.data.term
                ? { label: result.data.term, value: result.data.term_id }
                : "select",
              b_to: result.data.name || "",
              b_street: result.data.b_street || "",
              b_city: result.data.b_city || "",
              b_state: result.data.b_state || "",
              b_zip: result.data.b_zip || "",
              b_country: result.data.b_country || "",
              b_phone2: result.data.b_phone2 || "",
              s_to: result.data.s_attention_name || "",
              s_street: result.data.s_street || "",
              s_city: result.data.s_city || "",
              s_state: result.data.s_state || "",
              s_zip: result.data.s_zip || "",
              s_country: result.data.s_country || "",
              s_name: result.data.s_attention_name || "",
              s_phone: result.data.s_phone || "",
            }));
          })
          .catch((err) => console.log(err.message));
      } else setFormData((prev) => ({ ...prev, [e.name]: option }));
      const error = validateField(e.name, option, e.name);
      setErrors((prev) => ({ ...prev, [e.name]: error }));
    } else {
      if (e.name === "part")
        setPartData((prev) => ({ ...prev, [e.name]: "select" }));
      else setFormData((prev) => ({ ...prev, [e.name]: "select" }));
    }
  };

  const handleRadioChange = (name) => {
    if (name === "part")
      setPartData((prev) => ({
        ...prev,
        type: name,
        part: "select",
        qty: 1,
        price: 0,
      }));
    else if (name === "np")
      setPartData((prev) => ({
        ...prev,
        type: name,
        part: {
          label: `NP`,
          value: null,
          part_number: "NP",
          description: "",
          category: "=",
          unit: "-",
          sale_price: 0,
          cost_price: 0,
          bom_str: "",
          nonpart: true,
        },
        qty: 1,
        price: 0,
      }));
    else if (name === "ncp")
      setPartData((prev) => ({
        ...prev,
        type: name,
        part: {
          label: `NC`,
          value: null,
          part_number: "NC",
          description: "",
          category: "=",
          unit: "-",
          sale_price: 0,
          cost_price: 0,
          bom_str: "",
          nonpart: true,
        },
        qty: 1,
        price: 0,
      }));
  };

  const bufferToBase64 = (buffer) => {
    let binary = "";
    const bytes = new Uint8Array(buffer);
    const chunkSize = 0x8000; // 32KB chunks
    for (let i = 0; i < bytes.length; i += chunkSize) {
      const subarray = bytes.subarray(i, i + chunkSize);
      binary += String.fromCharCode.apply(null, subarray);
    }
    return btoa(binary);
  };

  const handleFileSelect = async (event) => {
    const files = event.target.files;
    if (!files) return;
    // Filter only PDF files
    const pdfFiles = Array.from(files).filter(
      (file) =>
        file.type === "application/pdf" ||
        file.name.toLowerCase().endsWith(".pdf"),
    );
    if (pdfFiles.length === 0) {
      showErrorToast("Error!", "Please select only PDF files");
      return;
    }
    const maxSize = 1 * 1024 * 1024; // 1 MB in bytes
    const invalidFiles = Array.from(files).filter(
      (file) => file.size > maxSize,
    );
    if (invalidFiles.length > 0) {
      showErrorToast("Error!", "One or more files exceed the 1MB limit!");
      event.target.value = "";
      return;
    }
    if (selectedFiles.length + pdfFiles.length > 4) {
      showErrorToast("Error!", "Maximum 4 files allowed!");
      event.target.value = "";
      return;
    }

    const newFiles = [];
    for (const file of pdfFiles) {
      try {
        const buffer = await file.arrayBuffer();
        // const base64 = await fileToBase64(file);
        const base64 = bufferToBase64(buffer);
        newFiles.push({
          id: null,
          file,
          name: file.name,
          size: file.size,
          base64: base64,
          note: "",
        });
      } catch (error) {
        console.error(`Error processing ${file.name}`, error);
      }
    }
    setSelectedFiles((prev) => [...prev, ...newFiles]);
    event.target.value = "";
  };

  const removeFile = (index) => {
    if (selectedFiles[index].id)
      setRemovedFiles((prev) => [...prev, selectedFiles[index].id]);
    setSelectedFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const downloadFile = async (id) => {
    const resp = await GetSaleOrderFileApi(id);
    if (!resp) showErrorToast("Error!", "File not found!");
  };

  const loadOptions = async (inputText, callback) => {
    if (inputText.length > 2 && store_id) {
      await getPartDataListByStoreFilter(store_id, inputText)
        .then((resp) => {
          const partOptions1 = resp.data.map((item) => ({
            label: `${item.part_number} - ${item.description}`,
            value: item.part_id,
            part_number: item.part_number,
            description: item.description,
            category: item.category,
            unit: item.unit,
            sale_price: item.sale_price,
            cost_price: item.cost_price,
            bom_str: item.bom_str,
            nonpart: false,
          }));
          setPartOptions(partOptions1 || []);
          callback(partOptions1 || []);
        })
        .catch((err) => console.log(err.message));
    } else callback(partOptions);
  };

  const handleToggle = (value) => {
    if (value.part_id) {
      TimeoutUtility.resetTimeout();
      setActiveProdMenuId({ part_id: value.part_id, store_id: store_id });
      setActiveProdMenu(true);
    }
  };

  const handleCopyClick = (e) => {
    e.preventDefault();
    TimeoutUtility.resetTimeout();
    setFormData((prev) => ({
      ...prev,
      s_to: formData.b_to,
      s_street: formData.b_street,
      s_city: formData.b_city,
      s_state: formData.b_state,
      s_zip: formData.b_zip,
      s_phone: formData.b_phone2,
      s_country: formData.b_country,
    }));
  };

  const handleAddNoteClick = (e) => {
    e.preventDefault();
    TimeoutUtility.resetTimeout();
    if (formData.so_notes?.notes)
      setFormData((prev) => ({
        ...prev,
        note: (prev.note + " \n\n" + formData.so_notes.notes).trim(),
      }));
  };

  const handleAddcartClick = () => {
    TimeoutUtility.resetTimeout();
    const newErrors = {};
    Object.keys(partData).forEach((key) => {
      const error = validateField(key, partData[key], key);
      if (error) newErrors[key] = error;
    });
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      return;
    }
    const defaultPart = {
      part_id: partData.part.value,
      name: partData.part.label,
      part_number: partData.part.part_number,
      details: partData.part.description,
      unit_price: parseFloat(partData.price),
      unit: partData.part.unit,
      cost_price: partData.part.cost_price,
      quantity: parseFloat(partData.qty),
      discount: 0,
      total: parseFloat(partData.price) * parseFloat(partData.qty),
      shipment: 0,
      image: null,
      req_date: "",
      ship_date: "",
      notes: "",
    };
    setPartData({ type: "part", part: "select", price: "0", qty: "1" });
    setCartList((prevPartList) => [...prevPartList, defaultPart]);
  };

  const handleSalesOrderClick = async (e, print_f = false, convert = false) => {
    e.preventDefault();
    TimeoutUtility.resetTimeout();
    setIsPageFrozen(true);

    const newErrors = {};
    let lasterr = {};
    Object.keys(formData).forEach((key) => {
      const error = validateField(key, formData[key], key);
      if (error) {
        lasterr = { key: key, error: error };
        newErrors[key] = error;
      }
    });
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      showErrorToast("Error!", ToTitle(lasterr.key) + " - " + lasterr.error);
      setIsPageFrozen(false);
      return;
    }
    if (CartList.length === 0) {
      showErrorToast("Error!", "Quotation Cart is empty!");
      setIsPageFrozen(false);
      return;
    }
    const uniqueValues = new Set(
      CartList.map((v) => String(v.part_id) + v.details + v.notes),
    );
    if (uniqueValues.size < CartList.length) {
      showErrorToast(
        "Error!",
        `Duplicate description and notes for same parts found.\nQuotation failed to update!`,
      );
      setIsPageFrozen(false);
      return;
    }
    try {
      const cartItems = CartList.map((item, i) => ({
        item_no: i + 1,
        part_id: item.part_id,
        part_number: item.part_number,
        part_description: item.details,
        quantity: parseFloat(item.quantity) || 0,
        price: parseFloat(item.unit_price) || 0,
        req_date: item.req_date || null,
        quantity_shipped: 0,
        date_shipped: null,
        item_note: item.notes,
        shipment_id: 0,
      }));
      var mainFormData = {
        quote_sale: formData.est_sale,
        quote_date: oDatetime,
        sale_date: null,
        sales_rep: formData.sales_rep,
        so_status_id: formData.status.value,
        store_id: store_id,
        customer_id: formData.customer.value,
        account_to_id: null,
        account_from_id: formData.customer.account_id,
        customer_po_no: formData.customer_po,
        term_id: formData.terms !== "select" ? formData.terms.value : null,
        payment_date: formData.amount_paid > 0 ? oDatetime : null,
        payment_status_id: null,
        amount_paid: formData.amount_paid,
        amount_pending: formData.amount_pending,
        ship_method_id:
          formData.ship_method !== "select" ? formData.ship_method.value : null,
        ref: formData.references,
        tracking_no: formData.tracking_no,
        user_id: userID,
        so_note: formData.note,
        user_note: formData.user_note,
        file: null,
        invoice: {
          so_id: 0,
          total_price: formData.grand_total,
          discount: formData.total_discount,
          discount_label: formData.discount_label,
          tax: formData.tax,
          shipment: formData.shipping,
          bill_amount: 0,
        },
        sale_order_parts: cartItems,
        sale_order_address: {
          so_id: 0,
          customer_id: formData.customer.value,
          bill_to: formData.b_to,
          billing_address: {
            street: formData.b_street,
            city: formData.b_city,
            state: formData.b_state,
            zip: formData.b_zip,
            country: formData.b_country,
            phone1: formData.b_phone2,
            phone2: "",
          },
          ship_to: formData.s_to,
          shipping_address: {
            street: formData.s_street,
            city: formData.s_city,
            state: formData.s_state,
            zip: formData.s_zip,
            country: formData.s_country,
            attention_name: "",
            phone: formData.s_phone,
          },
        },
      };
      const response = await EditSalesOrderApi(so_id_param, mainFormData);
      if (response.success) {
        if (selectedFiles.length > 0 && so_id_param)
          selectedFiles.forEach(async (file) => {
            if (file.id) return; // Skip already uploaded files
            var fileData = {
              so_id: so_id_param,
              file_name: file.name,
              file_doc: file.base64,
              note: file.note || `Quotation related file - ${file.name}`,
            };
            const uploadResp = await AddSalesOrderFileApi(fileData);
            if (!uploadResp.success)
              showErrorToast("Error!", "Order updated but file upload failed!");
          });
        if (removedFiles.length > 0 && so_id_param)
          removedFiles.forEach(async (id) => {
            const delResp = await DeleteSalesOrderFileApi(id);
            if (!delResp.success)
              showErrorToast("Error!", "Order updated but file delete failed!");
          });
        if (print_f && so_id_param) {
          if (window.confirm(`Do you want to show the price of this Quote?`)) {
            const resp = await PrintQuoteApi(so_id_param, true);
            if (!resp) showErrorToast("Error!", "Record not found!");
          } else {
            const resp = await PrintQuoteApi(so_id_param, false);
            if (!resp) showErrorToast("Error!", "Record not found!");
          }
        }
        showSuccessToast("Success!", "Quotation updated successfully.");
      } else {
        showErrorToast(
          "Error!",
          "Quotation failed to update!\n\n" + response.message,
        );
        setIsPageFrozen(false);
        return;
      }
      setTimeout(function () {
        if (convert) {
          window.open(`/Quotes/ConvertQuote/${so_id_param}`);
          window.close();
        } else window.location.reload();
      }, 1000);
    } catch (err) {
      console.error(err);
      showErrorToast("Error!", "Quotation failed to update!");
    } finally {
      setIsPageFrozen(false);
    }
  };

  const handlePrintOrderClick = async (e) =>
    handleSalesOrderClick(e, true, false);

  const handleSaveConvertClick = async (e) => {
    if (window.confirm(`Do you want to save & convert this quote to order?`))
      handleSalesOrderClick(e, false, true);
  };

  const handleNewClick = () => window.open(`/Quotes/AddQuotation`, "_blank");

  function ToTitle(snakeCaseString) {
    const spacedString = snakeCaseString.replace(/_/g, " ");
    const titleCaseString = spacedString.replace(/\b\w/g, (char) =>
      char.toUpperCase(),
    );
    return titleCaseString;
  }

  const formatCurrency = (number) => {
    return number.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
    });
  };

  const handleDeleteClick = async (str) => {
    TimeoutUtility.resetTimeout();
    const index = CartList.findIndex(
      (item) => String(item.part_id) + item.details + item.notes === str,
    );
    const rP = CartList[index];
    if (window.confirm(`Do you want to remove ${rP.part_number} from cart?`)) {
      const newCartList = [...CartList];
      newCartList.splice(index, 1);
      setCartList(newCartList);
    }
  };

  const updateTotals = useCallback(() => {
    if (!CartList?.length) return;
    let taxx = parseFloat(formData.tax) || 0;
    let ship = parseFloat(formData.shipping) || 0;
    let disc = parseFloat(formData.total_discount) || 0;
    let ampd = parseFloat(formData.amount_paid) || 0;

    const { totalAmt, totalItm } = CartList.reduce(
      (acc, item) => {
        acc.totalAmt += parseFloat(item.total);
        acc.totalItm += parseFloat(item.quantity) || 0;
        return acc;
      },
      { totalAmt: 0, totalItm: 0 },
    );
    taxx = (taxx / 100) * (totalAmt - disc);
    var grandTotal = totalAmt - disc + taxx + ship;
    var amountPend = grandTotal - ampd;

    setFormData((prev) => ({
      ...prev,
      sub_total: totalAmt,
      total_items: totalItm,
      grand_total: grandTotal,
      amount_pending: amountPend,
    }));
  }, [
    CartList,
    formData.tax,
    formData.shipping,
    formData.total_discount,
    formData.amount_paid,
  ]);

  useEffect(() => {
    updateTotals();
  }, [updateTotals]);

  useEffect(() => {
    TimeoutUtility.resetTimeout();
    async function fetchData() {
      if (!so_id_param) return;
      setloading(true);
      let storeId = 0;
      await GetSalesOrderDataByID(so_id_param)
        .then((resp) => (storeId = resp.data.store_id))
        .catch((err) => console.log(err.message));
      trackPromise(
        Promise.all([
          GetSalesOrderDataByID(so_id_param),
          GetSalesOrderPartsByID(so_id_param),
          GetCustListByStore(storeId),
          GetAllSOStatus(),
          GetAllSaleOrderNotes(),
          GetAllTerms(),
          GetAllShipMethod(),
        ])
          .then(
            ([res, partRes, custRes, sostRes, soNoteRes, termRes, shpmRes]) => {
              if (res.data.quote_sale !== "Q") {
                window.open(`/Quotes/AddQuotation`);
                window.close();
              }
              setStore_id(res.data.store_id);
              setODatetime(res.data.quote_date?.slice(0, -1));
              if (partRes.data && partRes.data.length > 0) {
                const partList = partRes.data.map((item) => {
                  return {
                    part_id: item.non_part ? null : item.part_id,
                    name: `${item.part_number} - ${item.part_description}`,
                    part_number: item.part_number || "",
                    details: item.part_description || "",
                    unit_price: item.price || 0,
                    unit: item.unit || "-",
                    cost_price: item.cost_price || 0,
                    quantity: item.quantity || 0,
                    discount: 0,
                    total:
                      parseFloat(item.price) * parseFloat(item.quantity) || 0,
                    shipment: item.quantity_shipped || 0,
                    image: null,
                    req_date: item.req_date ? item.req_date.split("T")[0] : "",
                    ship_date: item.date_shipped
                      ? item.date_shipped.split("T")[0]
                      : "",
                    notes: item.item_note || "",
                  };
                });
                setCartList(() => [...partList]);
              }
              const custOption = custRes.data.map((item) => ({
                label: item.name,
                value: item.customer_id,
                balance: item.balance,
                account_id: item.account_id,
                term_id: item.term_id,
              }));
              const custOld = custOption.find(
                (item) => item.value === res.data.customer_id,
              );
              setCustomerOptions(custOption || []);
              const type1Options = sostRes.data.map((item) => ({
                label: item.name,
                value: item.so_status_id,
              }));
              setSoStatusOptions(type1Options || []);
              const type5Options = soNoteRes.data.map((item) => ({
                label: item.title,
                notes: item.notes,
                value: item.note_id,
              }));
              setSoNoteOptions(type5Options || []);
              const typeOptions = termRes.data.map((item) => ({
                label: item.name,
                value: item.term_id,
              }));
              setTermsOptions(typeOptions || []);
              const type3Options = shpmRes.data.map((item) => ({
                label: item.name,
                value: item.ship_method_id,
              }));
              setShipMethodOptions(type3Options || []);
              const fileList = [];
              for (let i = 0; i < res.data.file_ids?.length; i++) {
                fileList.push({
                  id: res.data.file_ids[i],
                  file: null,
                  name: res.data.file_names[i],
                  size: 0,
                  base64: null,
                  note: "",
                });
              }
              setSelectedFiles(fileList);
              setFormData((prev) => ({
                ...prev,
                customer: custOld,
                customer_po: res.data.customer_po_no || "",
                sales_rep: res.data.sales_rep || "",
                terms: res.data.term
                  ? { label: res.data.term, value: res.data.term_id }
                  : "select",
                ship_method: {
                  label: res.data.ship_method,
                  value: res.data.ship_method_id,
                },
                tracking_no: res.data.tracking_no || "",
                b_to: res.data.bill_to || "",
                b_street: res.data.b_street || "",
                b_city: res.data.b_city || "",
                b_state: res.data.b_state || "",
                b_zip: res.data.b_zip || "",
                b_country: res.data.b_country || "",
                b_phone2: res.data.b_phone1 || "",
                s_to: res.data.ship_to || "",
                s_street: res.data.s_street || "",
                s_city: res.data.s_city || "",
                s_state: res.data.s_state || "",
                s_zip: res.data.s_zip || "",
                s_country: res.data.s_country || "",
                s_phone: res.data.s_phone || "",
                amount_paid: res.data.amount_paid || 0,
                total_discount: res.data.discount || 0,
                tax: res.data.tax || 0,
                shipping: res.data.shipment || 0,
                references: res.data.ref || "",
                note: res.data.so_note || "",
                user_note: res.data.user_note || "",
                store_id: res.data.store_id || 0,
                status: {
                  label: res.data.so_status,
                  value: res.data.so_status_id,
                },
                o_datetime: res.data.quote_date || "",
              }));
            },
          )
          .catch((err) => console.log(err.message))
          .finally(() => setloading(false)),
      );
    }
    fetchData();
  }, [so_id_param]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      {(loading || promiseInProgress || isPageFrozen) && (
        <div className="overlay-freeze">
          <LoadingIndicator />
        </div>
      )}
      <Container fluid className="g-0 p-0 justify-end">
        <Row xs={1} sm={1} className="p-0 justify-content-center">
          <Col md={5} className="container-col">
            <Header title="EDIT QUOTATION" />
          </Col>
          <Col md={2} className="container-col">
            <label
              className="status-box"
              style={{ backgroundColor: currentColor }}
            >
              Q # {so_id_param}
            </label>
          </Col>
          <Col md={2} className="container-col">
            <DateTimeField
              label="DateTime:"
              name="sale_date"
              value={oDatetime}
              placeholder="DateTime"
              now={false}
              disabled
              style={{ width: "178px" }}
            />
          </Col>
          <Col md={3} className="container-col">
            <label
              className="status-box"
              style={{ backgroundColor: currentColor }}
            >
              Quote Status:{" "}
              <select
                name="status"
                className="select status-box-select"
                style={{ backgroundColor: currentColor }}
                value={formData.status.label}
                onChange={handleChange}
              >
                {soStatusOptions.length > 0 &&
                  soStatusOptions?.map((item) => (
                    <option key={item.value}>{item.label}</option>
                  ))}
              </select>
            </label>
          </Col>
        </Row>
        <Row xs={1} sm={1} className="p-0 justify-content-center">
          <Col md={9} className="container-col">
            <div className="card-sale">
              <PosForm2
                formData={formData}
                partData={partData}
                errors={errors}
                currentColor={currentColor}
                CustomerOptions={CustomerOptions}
                termsOptions={termsOptions}
                loadOptions={loadOptions}
                type="quote"
                handleChange={handleChange}
                handleSelectChange={handleSelectChange}
                handleRadioChange={handleRadioChange}
                handleCopyClick={handleCopyClick}
                handleAddcartClick={handleAddcartClick}
              />
              <Row xs={1} sm={1} className="table-container-sale03">
                <CartListTable
                  CartList={CartList}
                  imagePerm={defaultImageMode && imageMode}
                  type="quote"
                  handleChange={handleChange}
                  handleDelete={handleDeleteClick}
                  handleToggle={handleToggle}
                  handleTotals={updateTotals}
                  loading={promiseInProgress || loading}
                />
              </Row>
            </div>
          </Col>
          <Col md={3} className="container-col">
            <div className="card-sale">
              <Row xs={1} sm={1} className="justify-content-center p-0">
                <Col md={6} className="container-col left-card">
                  <Card
                    className="action-btns-card"
                    style={{ background: isPageFrozen ? "#ccc" : currentColor }}
                    onClick={handleSalesOrderClick}
                  >
                    <div className="action-btn">SAVE</div>
                  </Card>
                </Col>
                <Col md={6} className="container-col right-card">
                  <Card
                    className="action-btns-card"
                    style={{ background: isPageFrozen ? "#ccc" : currentColor }}
                    onClick={handlePrintOrderClick}
                  >
                    <div className="action-btn">SAVE & PRINT</div>
                  </Card>
                </Col>
              </Row>
              <Row xs={1} sm={1} className="justify-content-center p-0">
                <Col md={6} className="container-col left-card">
                  <Card
                    className="action-btns-card"
                    style={{ background: isPageFrozen ? "#ccc" : currentColor }}
                    onClick={handleNewClick}
                  >
                    <div className="action-btn">NEW</div>
                  </Card>
                </Col>
                <Col md={6} className="container-col right-card">
                  <Card
                    className="action-btns-card"
                    style={{ background: isPageFrozen ? "#ccc" : currentColor }}
                    onClick={handleSaveConvertClick}
                  >
                    <div className="action-btn">SAVE & CONVERT</div>
                  </Card>
                </Col>
              </Row>
              <Row xs={1} sm={1} className="justify-content-center pl-3 pr-3">
                <Col md={6} className="container-col right-table-field">
                  <label>Sales Rep:</label>
                  <input
                    type="text"
                    name="sales_rep"
                    placeholder="Sales Rep"
                    value={formData.sales_rep}
                    onChange={handleChange}
                    className="input"
                  />
                  {errors.sales_rep && (
                    <p className="label-error-pos">{errors.sales_rep}</p>
                  )}
                </Col>
                <Col md={6} className="container-col right-table-field">
                  <label>Ship Method:</label>
                  <Select
                    className={"right-table-field-select"}
                    inputId={"ship_method"}
                    name="ship_method"
                    value={formData.ship_method}
                    options={shipMethodOptions}
                    placeholder="Select Ship Method"
                    onChange={handleSelectChange}
                  />
                  {errors.ship_method && (
                    <p className="label-error-pos-select">
                      {errors.ship_method}
                    </p>
                  )}
                </Col>
                <Col md={12} className="container-col right-table-field">
                  <label>Quote Notes:</label>
                  <textarea
                    placeholder="Quote Notes"
                    name="note"
                    id="note"
                    value={formData.note}
                    onChange={handleChange}
                    className="textarea"
                  />
                  {errors.note && (
                    <p className="label-error-pos">{errors.note}</p>
                  )}
                  <select
                    name="so_notes"
                    className="select"
                    style={{
                      color: currentColor,
                      fontWeight: "400",
                      height: "21px",
                      fontSize: "12px",
                      padding: "1px 6px",
                      width: "80%",
                    }}
                    value={formData.so_notes?.label}
                    onChange={handleChange}
                  >
                    <option key="select">[Notes Option]</option>
                    {soNoteOptions.length > 0 &&
                      soNoteOptions?.map((item) => (
                        <option key={item.value}>{item.label}</option>
                      ))}
                  </select>
                  <button
                    className="sale-bal"
                    type="button"
                    style={{
                      backgroundColor: currentColor,
                      fontWeight: "500",
                      fontSize: "14px",
                      color: "white",
                      padding: "0px 4px",
                      marginLeft: "4px",
                    }}
                    onClick={handleAddNoteClick}
                  >
                    +
                  </button>
                </Col>
                <Col md={12} className="container-col right-table-field">
                  <label>User Notes:</label>
                  <textarea
                    placeholder="User Notes"
                    name="user_note"
                    id="user_note"
                    value={formData.user_note}
                    onChange={handleChange}
                    className="textarea"
                  />
                  {errors.user_note && (
                    <p className="label-error-pos">{errors.user_note}</p>
                  )}
                </Col>
              </Row>
              <Row sm={1} className="justify-content-center mt-3 pl-3 pr-3 h-7">
                <Col md={6} className="container-col p-0 table1-sum-label">
                  Sub Total:
                </Col>
                <Col
                  md={6}
                  className="container-col p-0 table1-sum-cash"
                  style={{ color: currentColor }}
                >
                  {formatCurrency(formData.sub_total)}
                </Col>
              </Row>
              <Row sm={1} className="justify-content-center pl-3 pr-3 h-7">
                <Col md={6} className="container-col p-0 table1-sum-label">
                  <input
                    type="text"
                    name="discount_label"
                    value={formData.discount_label}
                    onChange={handleChange}
                    placeholder="Discount Label"
                    className="input table1-sum-tb2"
                  />
                  :
                </Col>
                <Col md={6} className="container-col p-0 table1-sum-cash">
                  <label style={{ color: currentColor }}>{"$"}</label>
                  <input
                    name="total_discount"
                    type="number"
                    min="0"
                    className="input table1-sum-tb"
                    value={formData.total_discount}
                    onChange={handleChange}
                    style={{ marginLeft: "6px", color: currentColor }}
                  />
                </Col>
              </Row>
              <Row sm={1} className="justify-content-center pl-3 pr-3 h-7">
                <Col md={6} className="container-col p-0 table1-sum-label">
                  Tax:
                </Col>
                <Col md={6} className="container-col p-0 table1-sum-cash">
                  <label style={{ color: currentColor }}>{"%"}</label>
                  <input
                    name="tax"
                    type="number"
                    min="0"
                    // max="100"
                    className="input table1-sum-tb"
                    value={formData.tax}
                    onChange={handleChange}
                    style={{ marginLeft: "2px", color: currentColor }}
                  />
                </Col>
              </Row>
              <Row sm={1} className="justify-content-center pl-3 pr-3 h-7">
                <Col md={6} className="container-col p-0 table1-sum-label">
                  Shipping:
                </Col>
                <Col md={6} className="container-col p-0 table1-sum-cash">
                  <label style={{ color: currentColor }}>{"$"}</label>
                  <input
                    name="shipping"
                    type="number"
                    min="0"
                    className="input table1-sum-tb"
                    value={formData.shipping}
                    onChange={handleChange}
                    style={{ marginLeft: "6px", color: currentColor }}
                  />
                </Col>
              </Row>
              <Row sm={1} className="justify-content-center pl-3 pr-3 h-7">
                <Col md={6} className="container-col p-0 table1-sum-label">
                  Grand Total:
                </Col>
                <Col
                  md={6}
                  className="container-col p-0 table1-sum-cash"
                  style={{ color: currentColor }}
                >
                  {formatCurrency(formData.grand_total)}
                </Col>
              </Row>
              <Row sm={1} className="justify-content-center pl-3 pr-3 h-7">
                <Col md={6} className="container-col p-0 table1-sum-label">
                  Total Items:
                </Col>
                <Col
                  md={6}
                  className="container-col p-0 table1-sum-cash"
                  style={{ color: currentColor }}
                >
                  {formData.total_items || 0}
                </Col>
              </Row>
              <Row xs={1} sm={1} className="justify-content-center pl-3 pr-3">
                <AttachFileOrder
                  selectedFiles={selectedFiles}
                  currentColor={currentColor}
                  loading={loading || promiseInProgress}
                  handleFileSelect={handleFileSelect}
                  removeFile={removeFile}
                  downloadFile={downloadFile}
                />
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
export default EditQuotation;
